import { render, staticRenderFns } from "./member_upgrade_page.vue?vue&type=template&id=66fa7baa&scoped=true"
import script from "./member_upgrade_page.vue?vue&type=script&lang=js"
export * from "./member_upgrade_page.vue?vue&type=script&lang=js"
import style0 from "./member_upgrade_page.vue?vue&type=style&index=0&id=66fa7baa&prod&lang=scss&scoped=true"
import style1 from "./member_upgrade_page.vue?vue&type=style&index=1&id=66fa7baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa7baa",
  null
  
)

export default component.exports